const viewProjectsDefaultAppSettings = {
    columns:            _.map(['2','22','6','23','5','26'], id=>({id: id/*, aggregate: null*/})),
    systemStatusFilter: 'open', // used is task table to show hide archived tasks
    sortBy:             null,  // current sort by column value
    filters:            {},
};


export default viewProjectsDefaultAppSettings